import { render, staticRenderFns } from "./AsistenciaSocio.vue?vue&type=template&id=44dc8840"
import script from "./AsistenciaSocio.vue?vue&type=script&lang=js"
export * from "./AsistenciaSocio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports